import {
    ModuleWithProviders,
    NgModule,
    Optional,
    SkipSelf
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { MenuComponent } from './components/menu/menu.component';
import { PageBadRequestComponent } from './components/page-bad-request/page-bad-request.component';
import { PageInternalServerErrorComponent } from './components/page-internal-server-error/page-internal-server-error.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { SubFooterComponent } from './components/sub-footer/sub-footer.component';
import { PageServiceUnavailableComponent } from './components/page-service-unavailable/page-service-unavailable.component';
import { LanguageSelectComponent } from '../i18n/components/language-select/language-select.component';
import { LanguageSelectorComponent } from '../i18n/containers/language-selector/language-selector.component';
import { A11yPageComponent } from './components/a11y-page/a11y-page.component';

const components = [
    HeaderComponent,
    FooterComponent,
    MenuComponent,
    PageNotFoundComponent,
    PageBadRequestComponent,
    PageInternalServerErrorComponent,
    PageServiceUnavailableComponent,
    SubFooterComponent,
    LanguageSelectComponent,
    LanguageSelectorComponent,
    A11yPageComponent
];

@NgModule({
    imports: [
        SharedModule,
        RouterModule
    ],
    declarations: components,
    exports: components
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        if (parentModule) {
            throw new Error('CoreModule has already been loaded. Import Core module in the AppModule only.');
        }
    }

    public static forRoot(): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule
        };
    }
}
